import ConfirmationContext from './ConfirmationContext'
import { useContext } from 'react'

const useConfirmation = () => useContext(ConfirmationContext)

export default useConfirmation
